import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class ComputerMenu {

  constructor(app) {
    this.app = app;
  }
  show(path, model) {
     model = this.getModel();

    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const userdata = app.userdata;
    const config = app.config;
    const achievement = app.achievements;
    const items = userdata.items || [];

    const fullVersion = !!userdata.fullVersion;
    const gameMode = userdata.gameMode;
    const showInsaneMonkey = items.includes("InsaneMonkey") || fullVersion;
    const showUltraCheetah = items.includes("UltraCheetah") || fullVersion;
    const showImpossible = items.includes("Impossible") || fullVersion;
    const showDoubles = items.includes("Doubles") || fullVersion;
    const showBigHand = items.includes("BigHand") || fullVersion;


    const model = {
      gameMode: gameMode,
      showInsaneMonkey: showInsaneMonkey,
      showUltraCheetah: showUltraCheetah,
      showImpossible: showImpossible,
      showDoubles: showDoubles,
      showBigHand: showBigHand,
      fullVersion: fullVersion
    };

    return model;
  }
  play(gameMode, level) {
    if(!gameMode)gameMode = "Classic";
    this.app.userdata.gameMode = gameMode;

    let href = `#/Game/${gameMode}/${level}`;
    window.location.href = href;
  }

}